import { AxInit, ModuleName } from "../../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../../Lib/AxSystem/AxLoad";
import { LoadingSpinnerPositionEnum } from "../../../Lib/Enums/LoadingSpinnerPositionEnum";
import { RequestHelper } from "../../../Lib/Helper/RequestHelper";
import { AxLoading } from "../../../Limestone/AxLoading/AxLoading";
import { ProductTriple } from "../../../Models/Products/ProductTriple";
import { ProductAndRiderDetailsService } from "../Services/ProductAndRiderDetailsService";
import * as components from "./RiderDetailsCompBundle";
import * as models from "./RiderDetailsModelBundle";

@ModuleName("RiderDetailsModule")
export class RiderDetailsModule implements AxInit {
    private axLoading: AxLoading;

    private addToCartBtn: HTMLButtonElement;

    private activeProductPortlet: components.ProductInfoPortlet;
    private productInfoPortlets: components.ProductInfoPortlet[] = [];
    private riderSelection: components.RiderSelection;
    private lockerDataComp: components.LockerData;
    private personDataForm: components.PersonDataForm;
    private rentalPropertiesSelection: components.RentalPropertiesSelection;
    private configRentalMandatoryProperties: boolean;
    private itemsData: itemsData[] = [];

    AxInit(init: IRentalRiderDetailsInit): void {        
        this.axLoading = new AxLoading();

        this.itemsData = init.items;
        this.riderSelection = new components.RiderSelection();
        this.configRentalMandatoryProperties = init.configRentalMandatoryProperties;
        this.initProductPortletComponents(init.model);

        this.productInfoPortlets[0].activatePortlet(true);
        this.initAddToCartBtn();
    }

    getAllProductInfoPortlets(): components.ProductInfoPortlet[] {
        return this.productInfoPortlets;
    }

    changeActiveProductPortlet(activatedProductPortlet: components.ProductInfoPortlet, firstLoad: boolean) {
        if (this.activeProductPortlet != undefined) {
            this.activeProductPortlet.checkFormValidityAndSetStates();
            this.activeProductPortlet.setPortletInActive();
        }

        if (!firstLoad) {
            this.riderSelection.showMobilePersonSelection();
        }

        this.activeProductPortlet = activatedProductPortlet;
        this.loadLockerPartial(activatedProductPortlet.getProductAndRiderDetails());
        this.loadRentalPropertiesSelection(activatedProductPortlet);
        this.updateLabelsAndPersonDataArea();
    }

    loadRentalPropertiesSelection(productPortlet: components.ProductInfoPortlet) {
        const holder = document.getElementsByClassName('rental_detail_rider__right_container-rental-properties')[0];
        holder.innerHTML = '';
        
        const prodAndRiderDetails = productPortlet.getProductAndRiderDetails();
        const item = this.itemsData.find((i) => (
            i.productTriple.id == prodAndRiderDetails.productTripleWithType.id
            && i.productTriple.productGroupIdentifier == prodAndRiderDetails.productTripleWithType.productGroupIdentifier
            && i.productTriple.projNr == prodAndRiderDetails.productTripleWithType.projNr
        ));

        this.rentalPropertiesSelection = new components.RentalPropertiesSelection(prodAndRiderDetails, this.configRentalMandatoryProperties, item);
    }

    loadAccountData(accountId: number) {
        const url = "/RentalRiderDetails/GetCustomerAccountRentalData";

        this.setAccountIdToProduct(accountId);

        const proAndRiderDetails = this.activeProductPortlet.getProductAndRiderDetails();

        const data = {
            addToCartFormModel: proAndRiderDetails
        }

        this.axLoading.ShowLoadingIndicatorGreyBackGround($('.rental_detail_rider__right_container-data-area')[0], LoadingSpinnerPositionEnum.Top);

        AxessViewer.loadPartialView(url, data, (res) => {
            const success: boolean = res.success;            
            if (!success) {

                if (res.ageCheckFailed) {
                    this.setAgeCheckFailedStatus(res.errorMsg);
                    this.axLoading.HideLoadingIndicator($('.rental_detail_rider__right_container-data-area')[0]);
                    $('.rental_detail_rider__btn-add_to_cart').prop("disabled", true);
                    return;
                }

                const requestHelper = new RequestHelper();
                requestHelper.postToUrl(`/${cultureInfo}/Rental/LandingPage`, {}, {});
            }

            $('.rental_detail_rider__right_container-person-data').html(res.returnView);

            if (this.lockerIncluded()) {
                this.lockerDataComp.setLockerData(proAndRiderDetails);
            }

            this.setValuesFromResultToProductAndRiderDetails(res);
            this.checkNextButtonAvailability(true);
            this.personDataForm = new components.PersonDataForm(res.customerRentalData.unitSystem);
            this.personDataForm.initInputsAsync(this.activeProductPortlet.getProductAndRiderDetails())
                .then(x => {
                    this.activeProductPortlet.updatePersonInfoTexts();
                    this.riderSelection.setSelectedPersonDataTexts(res.formattedDateOfBirth, res.customerRentalData.customerEmail);

                    this.activeProductPortlet.checkFormValidityAndSetStates();

                    this.axLoading.HideLoadingIndicator($('.rental_detail_rider__right_container-data-area')[0]);
                    this.riderSelection.hideAlertBanner(); 
                });
        }, {});
    }

    getLockerDataComponent(): components.LockerData {
        return this.lockerDataComp;
    }

    getPersonRentalDataForm(): components.PersonDataForm {
        return this.personDataForm;
    }

    getActiveProductPortlet(): components.ProductInfoPortlet {
        return this.activeProductPortlet;
    }

    lockerIncluded(): boolean {
        return $('.rental_customer_details-lockerWtp').length > 0;
    }

    private initProductPortletComponents(productAndRiderDetailsList: models.ProductAndRiderDetails[]) {
        const allPortlets = document.querySelectorAll(".rental_details_rider__product_portlet");

        for (let i = 0; i < allPortlets.length; i++) {
            const productPosition = allPortlets[i].getAttribute('rider-details-productPosition');
            const productAndRiderDetails = productAndRiderDetailsList.find(x => x.productPositionId === productPosition);
            const newPortlet = new components.ProductInfoPortlet(allPortlets[i] as HTMLDivElement, productAndRiderDetails);
            this.productInfoPortlets.push(newPortlet);            
        }
    }

    private initAddToCartBtn() {
        this.addToCartBtn = document.getElementsByClassName('rental_detail_rider__btn-add_to_cart')[0] as HTMLButtonElement;

        this.addToCartBtn.addEventListener("click",
            x => {
                this.getActiveProductPortlet().checkFormValidityAndSetStates().then(valid => {
                    if (!valid) {
                        return;
                    }

                    const everyThingSet = this.checkIfAllProductsHavePerson(false);        
                    const allMandatoryPropertiesSetted = this.areMandatoryProperties(false);                    
                    if (everyThingSet && allMandatoryPropertiesSetted) {
                        this.addToCart();
                        return;
                    }

                    let portlet = this.getActiveProductPortlet();

                    if (portlet) {
                        const index = this.productInfoPortlets.indexOf(portlet);
                        if (index < this.productInfoPortlets.length - 1) {
                            this.productInfoPortlets[index + 1].activatePortlet(false);
                            return;
                        }
                    }
                });
            });
    }    

    private checkIfAllProductsHavePerson(onlyActivePortlet: boolean): boolean {
        if (onlyActivePortlet) {
            return this.getActiveProductPortlet().getProductAndRiderDetails()?.riderData?.customerAccountId !== undefined;
        }
        else {
            let everyThingSet = true;

            for (let i = 0; i < this.productInfoPortlets.length; i++) {
                if (this.productInfoPortlets[i].getProductAndRiderDetails()?.riderData?.customerAccountId === undefined) {
                    everyThingSet = false;
                }
            }

            return everyThingSet;
        }        
    }    

    private areMandatoryProperties(onlyActivePortlet: boolean): boolean {        
        if (!this.configRentalMandatoryProperties) {
            return true;
        }

        const propertiesInDomToBeSet = onlyActivePortlet
            ? $('[data-mandatory-property="true"]').length
            : $('[data-mandatory-property="true"]').length * this.productInfoPortlets.length;
            
        if (propertiesInDomToBeSet === 0) {
            return true;
        }

        let setProperties = 0;

        if (onlyActivePortlet) {
            const portletInfo = this.getActiveProductPortlet().getProductAndRiderDetails();
            //Packages
            if (portletInfo.includedPackageItems.length > 0) {
                for (let j = 0; j < portletInfo.includedPackageItems.length; j++) {
                    if (portletInfo.includedPackageItems[j].selectedProperties) {
                        setProperties += portletInfo.includedPackageItems[j].selectedProperties.length;
                    }
                }
            }
            //Single Items
            else {
                setProperties += portletInfo.selectedProperties.length;
            }
        }
        else {
            for (let i = 0; i < this.productInfoPortlets.length; i++) {
                const portletInfo = this.productInfoPortlets[i].getProductAndRiderDetails();
                //Packages
                if (portletInfo.includedPackageItems.length > 0) {
                    for (let j = 0; j < portletInfo.includedPackageItems.length; j++) {
                        if (portletInfo.includedPackageItems[j].selectedProperties) {
                            setProperties += portletInfo.includedPackageItems[j].selectedProperties.length;
                        }
                    }
                }
                //Single Items
                else {
                    setProperties += portletInfo.selectedProperties.length;
                }
            }
        }        

        return propertiesInDomToBeSet === setProperties;
    }

    private checkNextButtonAvailability(onlyActivePortlet: boolean) {        
        const available = this.checkIfAllProductsHavePerson(onlyActivePortlet) && this.areMandatoryProperties(onlyActivePortlet);
        if (available) {
            $('.rental_detail_rider__btn-add_to_cart').prop("disabled", false);
        }
        else {
            $('.rental_detail_rider__btn-add_to_cart').prop("disabled", true);
        }        
    }

    private addToCart() {
        const url = "/RentalRiderDetails/AddRentalsToCart";

        this.axLoading.ShowLoadingIndicatorFixed($('.ax-content')[0]);
        
        let productAndRiderDetails = ProductAndRiderDetailsService.getInstance()
            .getProductAndRiderDetails(this.productInfoPortlets);
        AxessViewer.loadPartialView(url,
            {
                rentalDetailsProdInfos: productAndRiderDetails
            },
            (res) => {
                AxLoad.LoadModule('AxFireShoppingCartModal',
                    {
                        result: res,
                        continueShoppingPath: 'rental',
                        btn: '.rental_detail_rider__btn-add_to_cart',
                        ResetQuantity: null
                    });
                this.axLoading.HideLoadingIndicator($('.ax-content')[0]);
            },
            {
                silent: true,
                skipShoppingCartReload: false
            });
    }

    private updateLabelsAndPersonDataArea() {
        const productAndRiderDetails = this.activeProductPortlet.getProductAndRiderDetails();

        if (this.activeProductPortlet != undefined && productAndRiderDetails.customerAccountNr !== 0) {
            this.riderSelection.setDataAfterSelect(productAndRiderDetails);
            this.loadAccountData(productAndRiderDetails.customerAccountNr);
        } else {
            $('.rental_detail_rider__right_container-person-data').html("");
            this.riderSelection.resetPortlet();
        }
    }

    private loadLockerPartial(productAndRiderDetails: models.ProductAndRiderDetails) {
        // rentalItemType 1 = locker

        if (productAndRiderDetails.rentalItemType !== 1 &&
            productAndRiderDetails.includedPackageItems.every(x => x.rentalItemType !== 1)) {
            $('.rental_detail_rider__right_container-locker-data').html('');
            return;
        }

        const url = "/RentalRiderDetails/GetRiderDetailsLockerPartial";

        const data = {

        }

        AxessViewer.loadPartialView(url, data, (res) => {
            const success: boolean = res.success;

            if (!success) {
                return;
            }

            $('.rental_detail_rider__right_container-locker-data').html(res.returnView);

            this.lockerDataComp = new components.LockerData();
        }, {});
    }

    private setAgeCheckFailedStatus(errorMsg: string) {
        this.riderSelection.showAlertBanner(errorMsg, 'danger');

        this.riderSelection.resetDrownDown();

        const personDataForm = this.getPersonRentalDataForm();

        if (personDataForm != undefined) {
            personDataForm.setEmptyValues(this.activeProductPortlet.getProductAndRiderDetails());
            this.riderSelection.resetSelectedPersonDataTexts();
            this.activeProductPortlet.updatePersonInfoTexts();
        }

        this.activeProductPortlet.setUserNotSelectedState();

        $('.rental_detail_rider__right_container-person-data').html("");
    }

    private setAccountIdToProduct(accountId: number) {
        const prodDetails = this.activeProductPortlet.getProductAndRiderDetails();

        if (prodDetails.riderData == null || prodDetails.riderData == undefined) {
            prodDetails.riderData = new models.RiderData();
        }

        prodDetails.riderData.customerAccountId = accountId;
        prodDetails.customerAccountNr = accountId;
    }

    private setValuesFromResultToProductAndRiderDetails(res: any) {
        let productAndRiderDetails = this.activeProductPortlet.getProductAndRiderDetails();

        if (productAndRiderDetails.riderData == null || productAndRiderDetails.riderData == undefined) {
            productAndRiderDetails.riderData = new models.RiderData();
        }
        console.log(productAndRiderDetails.riderData);

        productAndRiderDetails.riderData.customerAccountId = res.customerRentalData.customerAccountId;

        productAndRiderDetails.riderData.shoeSizeSystem = res.customerRentalData.shoeSizeSystem;
        productAndRiderDetails.riderData.unitSystem = res.customerRentalData.unitSystem;

        productAndRiderDetails.riderData.customerName = res.customerRentalData.customerName;
        productAndRiderDetails.riderData.customerEmail = res.customerRentalData.customerEmail;
        productAndRiderDetails.riderData.dateOfBirth = res.customerRentalData.dateOfBirth;

        productAndRiderDetails.riderData.weight = res.customerRentalData.weight;
        productAndRiderDetails.riderData.height = res.customerRentalData.height;
        productAndRiderDetails.riderData.soleLength = res.customerRentalData.soleLength;
        productAndRiderDetails.riderData.shoeSize = res.customerRentalData.shoeSize;
        productAndRiderDetails.riderData.gender = res.customerRentalData.gender;
        productAndRiderDetails.riderData.skillLevel = res.customerRentalData.skillLevel;

        productAndRiderDetails.riderData.phone = res.customerRentalData.phone;

        productAndRiderDetails.riderData.city = res.customerRentalData.city;
        productAndRiderDetails.riderData.zipCode = res.customerRentalData.zipCode;
        productAndRiderDetails.riderData.country = res.customerRentalData.country;
        productAndRiderDetails.riderData.street = res.customerRentalData.street;
        //productAndRiderDetails.riderData.houseNumber = res.customerRentalData.houseNumber; // not yet needed
        productAndRiderDetails.riderData.state = res.customerRentalData.state;
        productAndRiderDetails.riderData.passportId = res.customerRentalData.passportId;
    }
}

export interface IRentalRiderDetailsInit {
    items: itemsData[];
    model: models.ProductAndRiderDetails[];
    configRentalMandatoryProperties: boolean;
}

export interface itemsData {
    type: ProductTypeNgEnum;
    productTriple: ProductTriple;
    price: number;
    name: string;
    productPositionId: string;
}

enum ProductTypeNgEnum
{
    Ticket = 0,
    Package = 1,
    Retail = 2,
    Article = 3,
    Rental = 4
}